<template>
    <div class="atlas_img">
        <div class="upload_btn">
            <p>补充附件</p>
            <input  type="file" @change="onchanged" :accept="format">
        </div>
        <!-- <div class="progress" v-show="showProgress">
            <el-progress :text-inside="true" :stroke-width="3" :percentage="docProcess"></el-progress>
        </div> -->
        
        <div class="file_name flex_between" v-show="xlsName&&uploadStatus">
            <span>{{xlsName}}</span>
            <p>
                <i @click="delImg" class="el-icon-circle-close del"></i>
                <i class="el-icon-circle-check ok"></i>
            </p>
        </div>
        <div class="file_name flex_between" v-show="existXls&&uploadStatus">
            <span>{{existXls}}</span>
            <p>
                <i @click="delImg" class="el-icon-circle-close del"></i>
                <i class="el-icon-circle-check ok"></i>
            </p>
        </div>
        <!-- <div class="format_tip">支持.png/jpg/.svg/.xls格式的文件,每个文档不超过{{limit}}MB</div> -->
        
        <div class="tip" v-show="showErr">{{errorTips}}</div>
    </div>
</template>
<script>
export default {
    name:'atlasImg',
    props:{
        existXls:String,
        format:String,
        limit:Number,
        showStyle:String,
        upStyle:String,
        errorTips:String,
        showErr:Boolean,
        uploadStatus:Boolean,
       
    },
    data(){
        return{
            xlsName:'',
          
        }
    },
    methods:{
        onchanged(e){
            let file = e.target.files[0]
            
            let formdata = new FormData()
            formdata.append("file", e.target.files[0])
            let filemaxsize = 1024*Number(this.limit);//2M
            var size = file.size / 1024;
            
            if(size>filemaxsize){
                this.$DonMessage.error("文件大小不能大于"+filemaxsize/1024+"M！");
                return false;
            }
            
            this.xlsName = file.name
            this.$emit('upPicGroupImg',formdata)
            e.target.value = ''
        },
        delImg(){
            this.xlsName = ''
            this.$emit('delUploadDoc')
        
        },
    }
}
</script>
<style lang="scss" scoped>
.atlas_img{
    .upload_btn{
        width: 80px;
        height: 32px;
        background: #409EFF;
        cursor: pointer;
        border-radius: 3px;
        position: relative;
        p{
            cursor: pointer;
            width: 80px;
            height: 32px;
            color: #fff;
            font-size: 12px;
            text-align: center;
            line-height: 32px;
        }
        input{
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 3;
            position: absolute;
            left: 0;
            top: 0;
            cursor: pointer;
        }
        
    }
    .upload_btn:hover{
        background: rgba($color: #409EFF, $alpha: 0.6);
    }
    ::v-deep .el-progress-bar{
        width: 100px!important;
    }
    .file_name{
        width: 200px;
        height: 30px;
        border-bottom: 2px solid #409EFF;
        box-sizing: border-box;
        span{
            font-size: 12px;
            line-height: 30px;
            
            color: #969696;
        }
        p{
            .del{
                display: none;
            }
        }
        p:hover{
            .del{
                display: block;
            }
            .ok{
                display: none;
            }
        }
        i{
            
            font-size: 18px;
            line-height: 30px;
            font-weight: bold;
            cursor: pointer;
        }
        .del{
            color: #F56C6C;
        }
        .ok{
            color: #67C23A;
        }

    }
    .format_tip{
        width: 200px;
        font-size: 12px;
        color: #333333;
        line-height: 15px;
    }
    .tip{
      font-size: 12px;
      color: #F56C6C;
      line-height: 20px;
    }

}
    

</style>